import React from 'react';
import AuthorizationLayout from '../../Layout/AuthorizationLayout';
import background from '../../../../assets/images/auth_background.png';
import { TFunction, useTranslation } from 'react-i18next';
import alStyles from '../../Layout/AuthorizationLayout.module.scss';
import { Routes, Route } from 'react-router-dom';
import SignUpMainFormStep from './Steps/MainForm/SignUpMainFormStep';
import AuthorizationLayoutTablet from '../../Layout/Tablet/AuthorizationLayoutTablet';
import SignUpConfirmStepDesktop from './Steps/Confirm/SignUpConfirmStepDesktop';
import SignUpGreatWorkStepDesktop from './Steps/GreatWork/SignUpGreatWorkStepDesktop';

const getSubtitle = (t: TFunction<'translation', undefined>) => (
  <>
    <span className={alStyles.subtitleBold}>{t('signup.intro.subtitle1')}</span>&nbsp;<span>{t('signup.intro.subtitle2')}</span>
  </>
);

function SignUpPageDesktop() {
  const { t } = useTranslation();
  const subtitle = getSubtitle(t);
  return (
    <AuthorizationLayout
      background={background}
      subtitle={subtitle}
      title={t('signup.intro.title')}
      description={t('signup.intro.description')}
    >
      <AuthorizationLayoutTablet>
        <Routes>
          <Route path={'/'} element={<SignUpMainFormStep />} />
          <Route path={'/confirm'} element={<SignUpConfirmStepDesktop />} />
          <Route path={'/success'} element={<SignUpGreatWorkStepDesktop />} />
        </Routes>
      </AuthorizationLayoutTablet>
    </AuthorizationLayout>
  );
}

export default SignUpPageDesktop;
